/* src/app/main-layout/components/subitem-nav/subitem-nav.component.css */
@layer properties;
a {
  transition-property:
    color,
    background-color,
    border-color,
    outline-color,
    text-decoration-color,
    fill,
    stroke,
    --tw-gradient-from,
    --tw-gradient-via,
    --tw-gradient-to;
  transition-timing-function: var(--tw-ease, var(--default-transition-timing-function, cubic-bezier(0.4, 0, 0.2, 1)));
  transition-duration: var(--tw-duration, var(--default-transition-duration, 150ms));
  --tw-duration: 200ms;
  transition-duration: 200ms;
  --tw-ease: var(--ease-in-out, cubic-bezier(0.4, 0, 0.2, 1));
  transition-timing-function: var(--ease-in-out, cubic-bezier(0.4, 0, 0.2, 1));
}
a.active,
a:hover {
  background-color: var(--color-success-hover, #226e42);
}
.submenu-list {
  margin-bottom: calc(var(--spacing, 0.25rem) * 0);
  list-style-type: none;
  padding-inline-start: calc(var(--spacing, 0.25rem) * 0);
}
.submenu-link {
  display: block;
  padding: calc(var(--spacing, 0.25rem) * 3);
  text-align: start;
  font-size: var(--text-xs, 0.75rem);
  line-height: var(--tw-leading, var(--text-xs--line-height, calc(1 / 0.75)));
  color: var(--color-white, #fff);
  text-decoration-line: none;
}
.sidebar {
  position: fixed;
  top: calc(var(--spacing, 0.25rem) * 0);
  left: 100%;
  z-index: 5;
  display: block;
  min-width: calc(var(--spacing, 0.25rem) * 56);
  transition-property: all;
  transition-timing-function: var(--tw-ease, var(--default-transition-timing-function, cubic-bezier(0.4, 0, 0.2, 1)));
  transition-duration: var(--tw-duration, var(--default-transition-duration, 150ms));
  --tw-duration: 200ms;
  transition-duration: 200ms;
  --tw-ease: cubic-bezier(0.5,0,0.1,1);
  transition-timing-function: cubic-bezier(0.5, 0, 0.1, 1);
}
.sidebar li {
  margin-left: calc(var(--spacing, 0.25rem) * 4);
  background-color: var(--color-primary-500, #257948);
}
.sidebar::before {
  position: absolute;
  top: calc(var(--spacing, 0.25rem) * 5);
  left: calc(var(--spacing, 0.25rem) * 0);
  margin-top: calc(var(--spacing, 0.25rem) * -2);
  display: block;
  border-style: var(--tw-border-style);
  border-width: 0.5rem;
  border-block-color: transparent;
  border-right-color: transparent;
  border-left-color: var(--color-primary-400, #2e9259);
  --tw-content: "";
  content: var(--tw-content);
}
.sidebar.arrowAtBottom::before {
  top: auto;
  bottom: calc(var(--spacing, 0.25rem) * 3.5);
}
@property --tw-duration { syntax: "*"; inherits: false; }
@property --tw-ease { syntax: "*"; inherits: false; }
@property --tw-border-style { syntax: "*"; inherits: false; initial-value: solid; }
@property --tw-content { syntax: "*"; inherits: false; initial-value: ""; }
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *,
    ::before,
    ::after,
    ::backdrop {
      --tw-duration: initial;
      --tw-ease: initial;
      --tw-border-style: solid;
      --tw-content: "";
    }
  }
}
/*! tailwindcss v4.3.0 | MIT License | https://tailwindcss.com */
/*# sourceMappingURL=subitem-nav.component.css.map */
